import type { IAppEnvironment } from '@bp/shared/typings';

export const environment: Partial<IAppEnvironment> = {
	sentry: 'https://dfccbae6dbd848a990ccff2aa92f75fc@o205478.ingest.sentry.io/5456161',
	logrocket: 'fpkaz5/prod-bridger-admin',
};
